import {
    CloseResourceCardTask,
    GetActiveResourceCardsTask,
    SubscribeToResourceCardsTask,
} from '@/Core/Tasks/Resources/OpenResourceCardTask'

import type { IActiveResourceCard } from '@/Core/Tasks/Resources/OpenResourceCardTask'

/**
 * Відкриті картки пропозицій — за ключем ресурсу, а не за ідентифікатором
 * картки, який повернув `OpenResourceCardTask`.
 *
 * ⚠️ «Редагувати» в ядрі **замінює** картку новою (`EditActionHandlerTask`,
 * `replace: true`): у неї інший ідентифікатор і власний `onClose`, тож ні
 * збережений ідентифікатор, ні `onClose` блоку після переходу в редагування
 * вже не спрацьовують. Ядровий `crudContext.closeResourceDetail` теж не
 * годиться: картки одного ресурсу ділять `crudContext`, і він вказує на
 * першу закриту шухляду.
 */
const isOfferCard = (card: IActiveResourceCard, resource: string): boolean =>
    typeof card.resource === 'string' ? card.resource === resource : card.resource?.key === resource

/** Закриває відкриті картки ресурсу пропозицій. */
export const closeOfferCards = (resource: string): void => {
    GetActiveResourceCardsTask()
        .filter((card) => isOfferCard(card, resource))
        .forEach((card) => CloseResourceCardTask(card.id))
}

/**
 * Викликає `onAllClosed`, коли закривається остання відкрита картка ресурсу —
 * хоч хрестиком, хоч після збереження. Повертає відписку.
 */
export const watchOfferCardsClosed = (resource: string, onAllClosed: () => void): (() => void) => {
    let wasOpen = GetActiveResourceCardsTask().some((card) => isOfferCard(card, resource))

    return SubscribeToResourceCardsTask((cards) => {
        const isOpen = cards.some((card) => isOfferCard(card, resource))

        if (wasOpen && !isOpen) onAllClosed()

        wasOpen = isOpen
    })
}
